<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Salary table</h6>
        <div class="row">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date From</label>
                <input type="date" id="input_date" class="form-control" v-model="search.datefrom">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date To</label>
                <input type="date" id="input_date" class="form-control" v-model="search.dateto">
            </div>
            <div class="col-md-1">
              <label for="example-text-input" class="form-control-label">Status</label>
              <select class="form-control" v-model="search.status">
                  <option value="%">All</option>
                  <option value="0">Pending</option>
                  <option value="1">Paid</option>
                  <option value="2">Cancel</option>
              </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Empcode</label>
                <select class="form-control" v-model="search.empcode">
                  <option value="%">All</option>
                  <option v-for="(item,index) in employeeList" :key="index" :value="item.empcode">
                      {{ item.empcode }} - {{ item.race_desc }} - {{ item.name }} 
                  </option>
              </select>
                <!-- <input class="form-control" v-model="search.vehicleno" id="input_vehicleno" type="text" placeholder="KCB8028" /> -->
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success" @click="listAllSalary">Search</button>
                <button class="btn btn-primary me-3" style="float:right;" @click="exportSalaryTable">Export</button>
            </div>
        </div>
      </div>
      <hr />
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-xs font-weight-bolder">
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Employee
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Basic
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Other
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Details
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Date
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Total
                </th>
                <!-- <th class="text-secondary opacity-7"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(salaryObj,index) in paginatedSalary" :key="index">
                <td style="width:4%">
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*perPage + index +1 }}.</h6>
                    </div>
                  </div>
                </td>
                <td class="align-middle text-xs " style="width:10%">
                  <span class="font-weight-bold" >
                    {{ salaryObj.name }}
                    </span>
                </td>
                <td class="align-middle" style="width:15%">
                    <span class="text-xs">Basic: RM</span><span class="font-weight-bold" >{{ salaryObj.basic }} </span><br /> 
                    <span class="text-xs">Hour:</span><span class="font-weight-bold" >{{ salaryObj.hour }}</span><br />
                    <span class="text-xs">OT: RM </span><span class="font-weight-bold" >{{ salaryObj.ot }} </span><br /> 
                    <span class="text-xs">OT Hour:</span><span class="font-weight-bold" >{{ salaryObj.ot_hour }}</span>
                </td>
                <td class="align-middle text-xs " style="width:20%">
                  <span class="font-weight-bold" >
                    Deduct: RM <span style="color: red;">({{ salaryObj.deduct }})</span><br />
                    Duit Makan: RM {{ salaryObj.duitmakan }}<br />
                    Bonus: RM {{ salaryObj.bonus }} <br />
                    Socso: RM {{ salaryObj.socso }} ({{ salaryObj.socso_rate }} %)<br />
                    Epf: RM {{ salaryObj.epf }} ({{ salaryObj.epf_rate }} %)
                    </span>
                </td>
                <td class="align-middle text-xs " style="width:20%">
                  <span v-if="salaryObj.status == '0'" class="badge badge-sm bg-gradient-info text-xs">Pending</span>
                  <span v-else-if="salaryObj.status == '1'" class="badge badge-sm bg-gradient-success text-xs">Paid</span>
                  <span v-else class="badge badge-sm bg-gradient-warning text-xs">Cancel</span>
                  <br />
                  <span class="font-weight-bold" >
                    Remark: {{ salaryObj.remark }}<br />
                    Period: {{ salaryObj.period_desc }}
                  </span>
                  <br />
                </td>
                <td class="align-middle" style="width:10%">
                    <span class="text-xs">Salary Date: </span><span class="font-weight-bold" >{{ salaryObj.date }}</span><br />
                    <span class="text-xs">Update Date: </span><span class="font-weight-bold" >{{ salaryObj.updated_date }}</span>
                </td>
                <td class="align-middle" style="width:16%">
                    <span class="text-xs">Sub Total: RM </span><span class="font-weight-bold" >{{ salaryObj.subtotal }}</span><br />
                    <span class="text-xs">Total: RM </span><span class="font-weight-bold" >{{ salaryObj.total }}</span>
                </td>
              </tr>
              <tr>
                <!-- <td><span class="font-weight-bold">{{ totalSalary.count }}</span></td> -->
                <td colspan="2"><span class="font-weight-bold">Basic:RM {{ totalSalary.basic }}</span></td>
                <td><span class="font-weight-bold">OT:RM {{ totalSalary.ot }}</span></td>
                <td><span class="font-weight-bold">Duit Makan:RM {{ totalSalary.duitmakan }}</span></td>
                <td><span class="font-weight-bold">Bonus:RM {{ totalSalary.bonus }}</span></td>
                <td><span class="font-weight-bold">Total:RM {{ totalSalary.total }}</span></td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-containe">
            <div class="row">
                <div class="col-md-10">
                    <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info me-3">Previous</button>
                    <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
                    <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
import axios from 'axios';

export default {
  name:'SalaryPendingSelect',
  data(){
    return {
        totalRows: 0,
        currentPage: 0,
        perPage: 10,
        searchQuery:'',
        salaryList:[],
        employeeList:[],
        totalSalary:{
          basic:0,
          ot:0,
          duitmakan:0,
          bonus:0,
          total:0,
          count:0
        },
        search:{
          dateto: new Date().toISOString().slice(0,10),
          datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
          status: '%',
          empcode: '%',
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.salaryList.length / this.perPage);
    },
    paginatedSalary() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();
      // Filter salaryList by checking all properties in each row
      let filtered = this.salaryList.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.listAllSalary();
    this.listAllEmployee();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    listAllSalary(){
      axios.get('payroll/listAllSalary/'+ this.search.status+'/' + this.search.datefrom + '/'+ this.search.dateto+'/'+this.search.empcode)
        .then(res => {
            this.salaryList = res.data.salaryList;
            this.currentPage = 1;
            this.totalSalary.basic = 0;
            this.totalSalary.ot = 0;
            this.totalSalary.duitmakan = 0;
            this.totalSalary.bonus = 0;
            this.totalSalary.total = 0;
            this.totalSalary.count = 0;

            
            this.salaryList.forEach(element => {
              this.totalSalary.basic = this.totalSalary.basic + (element.basic * element.hour);
              this.totalSalary.ot = this.totalSalary.ot + (element.ot * element.ot_hour);
              this.totalSalary.duitmakan = this.totalSalary.duitmakan + element.duitmakan;
              this.totalSalary.bonus = this.totalSalary.bonus + element.bonus;
              this.totalSalary.total = this.totalSalary.total + element.total;
              this.totalSalary.count = this.totalSalary.count + 1;
            });
        }).catch(function (error){
            console.log('Error',error.message);
        });
    },
    listAllEmployee(){
        axios.get('payroll/listAllEmployee')
            .then(res => {
              this.employeeList = res.data.employeeList;
              
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    exportSalaryTable(){
      
      let exportSalaryList = [];
      this.salaryList.forEach(e => {
        exportSalaryList.push({
                "Empcode":e.empcode,
                "Name": e.name,
                "Date":e.date,
                "Type":e.type_desc,
                "Period":e.period_desc,
                "Basic (RM)": e.basic,
                "Basic (Hour)": e.hour,
                "OT (RM)": e.ot,
                "OT (Hour)": e.ot_hour,
                "Duit Makan (RM)": e.duitmakan,
                "Bonus (RM)": e.bonus,
                "Socso (RM)": e.socso,
                "Socso Rate (%)": e.socso_rate,
                "EPF (RM)": e.epf,
                "EPF Rate (%)": e.epf_rate,
                "Total (RM)": e.total,
                "Status": e.status_desc,
                "Remark": e.remark,
            });
        });
        if(exportSalaryList.length<0 || (exportSalaryList == '') ){
            alert("Please search the salary pls. ");
        }else{
            let fileName = 'SalaryList_' + this.search.datefrom + '_' + this.search.dateto + '_' + this.search.status + '_' + this.search.empcode;
            const csvContent = this.convertToCSV(exportSalaryList);
            const blob = new Blob([csvContent],{type:'text/csv;charset=utf-8'});
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',fileName+'.csv');
            link.click();
        }
    },
    convertToCSV(data){
        const headers = Object.keys(data[0]);
        const rows = data.map(obj => headers.map(header => obj[header]));
        const headerRow = headers.join(',');
        const csvRows = [headerRow, ...rows.map(row => row.join(','))];

        return csvRows.join('\n');

    }
  },
}
</script>